import { render, staticRenderFns } from "./UpdatesForm.vue?vue&type=template&id=314a8308"
import script from "./UpdatesForm.vue?vue&type=script&lang=js"
export * from "./UpdatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports